<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <FreeUserTopOffer :customerInfo="customerInfo"/>
      <!-- <component
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :step="step"/> -->
    </div>
  </b-container>
</template>

<script>
import FreeUserTopOffer from "@/components/centre/free-user/FreeUserTopOffer.vue";

export default {
  title: "Dropsmart Center - Free user",
  name: "FreeUser",
  props: ["page", "customerInfo", "step"],
  components: {
    FreeUserTopOffer,
  },
  mounted() {
    let target = this.page ? this.page : "FreeUser";
    console.log("navigating to " + target);
    // this.navigate(target);
  },
  data() {
    return {
      content: null,
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style scoped lang="scss">

</style>